export default __webpack_public_path__ + "static/media/twitter.d74667dc.svg";